import request from '@/utils/request'
import {
  requestUrl
} from './requestUrl.js'


export function setPostSingupData(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setPostSingupData',
    method: 'POST',
    data:query
  })
}


export function getUserEditData(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getUserEditData',
    method: 'POST',
    data:query
  })
}


export function setSendSMSCode(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setSendSMSCode',
    method: 'POST',
    data:query
  })
}


export function showSingUpData(query) {
  return request({
    url:requestUrl.baseUrl + '/index/showSingUpData',
    method: 'POST',
    data:query
  })
}


// v3新增接口 开始
export function setTopicesFileName (query) {
  return request({
    url:requestUrl.baseUrl + '/index/setTopicesFileName',
    method: 'POST',
    data:query
  })
}

export function delTopicesSinglsFileRow (query) {
  return request({
    url:requestUrl.baseUrl + '/index/delTopicesSinglsFileRow',
    method: 'POST',
    data:query
  })
}


export function setNewUploadDataSave (query) {
  return request({
    url:requestUrl.baseUrl + '/index/setNewUploadDataSave',
    method: 'POST',
    data:query
  })
}

export function getTopicsShowFileList (query) {
  return request({
    url:requestUrl.baseUrl + '/index/getTopicsShowFileList',
    method: 'POST',
    data:query
  })
}

export function addTopicesSinglsRow (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/addTopicesSinglsRow',
    method: 'POST',
    data:query
  })
}


export function getFeedbackDetail(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getFeedbackDetail',
    method: 'POST',
    data:query
  })
}


export function setSaveNewFeedback(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setSaveNewFeedback',
    method: 'POST',
    data:query
  })
}


export function getFeedbackMainList(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getFeedbackMainList',
    method: 'POST',
    data:query
  })
}


export function getStaffLogData(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getStaffLogData',
    method: 'POST',
    data:query
  })
}


export function recycleTopicsToNormal(query) {
  return request({
    url:requestUrl.baseUrl + '/index/recycleTopicsToNormal',
    method: 'POST',
    data:query
  })
}

export function recycleTopicsToFile(query) {
  return request({
    url:requestUrl.baseUrl + '/index/recycleTopicsToFile',
    method: 'POST',
    data:query
  })
}

export function setFinalDelTopics(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setFinalDelTopics',
    method: 'POST',
    data:query
  })
}

export function getDelTopicsList(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getDelTopicsList',
    method: 'POST',
    data:query
  })
}

export function searchDelTopic(query) {
  return request({
    url:requestUrl.baseUrl + '/index/searchDelTopic',
    method: 'POST',
    data:query
  })
}


export function setRecoverFileTopics(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setRecoverFileTopics',
    method: 'POST',
    data:query
  })
}


export function searchFileTopic(query) {
  return request({
    url:requestUrl.baseUrl + '/index/searchFileTopic',
    method: 'POST',
    data:query
  })
}

export function getTopicsFileList(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getTopicsFileList',
    method: 'POST',
    data:query
  })
}

export function setTopicsToFile(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setTopicsToFile',
    method: 'POST',
    data:query
  })
}

export function searchNormalTopic(query) {
  return request({
    url:requestUrl.baseUrl + '/index/searchNormalTopic',
    method: 'POST',
    data:query
  })
}

// v3新增接口 结束

export function loginOut(query) {
  return request({
    url:requestUrl.baseUrl + '/index/loginOut',
    method: 'POST',
    data:query
  })
}


export function setDeleteAccount(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setDeleteAccount',
    method: 'POST',
    data:query
  })
}


export function setEditAccount(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setEditAccount',
    method: 'POST',
    data:query
  })
}

export function getUserDataList(query) {
  return request({
    url:requestUrl.baseUrl + '/index/getUserDataList',
    method: 'POST',
    data:query
  })
}

export function setDelTopics(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setDelTopics',
    method: 'POST',
    data:query
  })
}

export function setOpenTopics(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setOpenTopics',
    method: 'POST',
    data:query
  })
}

export function setCloseTopics(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setCloseTopics',
    method: 'POST',
    data:query
  })
}


export function setSaveSingupData(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setSaveSingupData',
    method: 'POST',
    data:query
  })
}

export function setCloseAccount(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setCloseAccount',
    method: 'POST',
    data:query
  })
}

export function setOpenAccount(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setOpenAccount',
    method: 'POST',
    data:query
  })
}


export function setSaveNewSysUser(query) {
  return request({
    url:requestUrl.baseUrl + '/index/setSaveNewSysUser',
    method: 'POST',
    data:query
  })
}

export function getSysUserList (query) {
  return request({
    url:requestUrl.baseUrl + '/index/getSysUserList',
    method: 'POST',
    data:query
  })
}


export function loginUserdata (query) {
  return request({
    url:requestUrl.baseUrl + '/index/loginUserdata',
    method: 'POST',
    data:query
  })
}


export function postSingleCaseEditData (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/postSingleCaseEditData',
    method: 'POST',
    data:query
  })
}

export function getSingleCaseAllGrade (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/getSingleCaseAllGrade',
    method: 'POST',
    data:query
  })
}


export function getSpecialist (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/getSpecialist',
    method: 'POST',
    data:query
  })
}

export function getSingleGrageDetail (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/getSingleGrageDetail',
    method: 'POST',
    data:query
  })
}


export function getGradeListDetail (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/getGradeListDetail',
    method: 'POST',
    data:query
  })
}


export function sendGradeTopics (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/sendGradeTopics',
    method: 'POST',
    data:query
  })
}


export function getTopicsList (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/getTopicsList',
    method: 'POST',
    data:query
  })
}


export function getTopicsDetail (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/getTopicsDetail',
    method: 'POST',
    data:query
  })
}


export function checkLogin (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/checkLogin',
    method: 'POST',
    data:query
  })
}


export function delTopicesSinglsRow (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/delTopicesSinglsRow',
    method: 'POST',
    data:query
  })
}

export function delTopicesRow (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/delTopicesRow',
    method: 'POST',
    data:query
  })
}

export function editTopicesSinglsRow (query) {
  return request({
    
    url:requestUrl.baseUrl + '/index/editTopicesSinglsRow',
    method: 'POST',
    data:query
  })
}